import React, { useRef } from 'react';
import ControlSwitch from '@/Shared/Form/ControlSwitch';
import { useFormContext, useWatch } from 'react-hook-form';
import Input from '@/Shared/Form/Input';

const RequiredByLaw = () => {
  const { control, formState: { errors } } = useFormContext();
  const isSelected = useWatch({ name: 'requiredByLaw', control });

  return (
    <React.Fragment>
      <div className="mb-3">
        <ControlSwitch
          labelOff='No'
          labelOn='Yes'
          name='requiredByLaw'
        />
      </div>
      {isSelected && (
        <Input
          isRequired
          labelText='Please list the data that is required by law and describe the legal basis'
          name='requiredByLawValue'
          type='text'
          placeholder='e.g. "Billing address and VAT number are required for tax compliance in the EU"'
        />
      )}
    </React.Fragment>
  );
};

export default RequiredByLaw;